module.exports = __webpack_public_path__ + "static/img/SV.6ae12f59.png";